import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import Button from '@strava/ui/Button';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import { useFrontDoorsPageContainerContext } from '../../../../../../state/FrontDoorsPageContainerContext';
import CallToAction from '../../../../../CallToAction';

import 'react-modern-drawer/dist/index.css';
import styles from './MenuDrawer.module.scss';

const MenuDrawer = ({ isOpen, top, onClose }) => {
  const {
    t,
    onMobileHeaderMenuSignupBtnClick,
    onMobileHeaderMenuLoginBtnClick
  } = useFrontDoorsPageContainerContext();

  const PRIMARY_OPTIONS = [
    { key: 'home', destination: '/' },
    { key: 'features', destination: '/features' },
    {
      key: 'subscription',
      destination: '/subscribe?origin=website_header'
    }
  ];

  const SECONDARY_OPTIONS = [
    {
      key: 'stories',
      destination: 'https://stories.strava.com/'
    },
    {
      key: 'support',
      destination: 'https://support.strava.com/'
    },
    {
      key: 'sign_up',
      destination:
        '/register/free?cta=sign-up&element=mobile-nav&source=website_show'
    }
  ];

  const [location, setLocation] = useState('');

  useEffect(() => {
    setLocation(window.location.pathname);
  }, []);

  const handleLoginBtnClick = () => {
    onMobileHeaderMenuLoginBtnClick();
    window.location.href = '/login';
  };

  const generateLinkProps = ({ key, destination }) => {
    return {
      'data-cy': `primary_option_${key}`,
      className: clsx({
        [styles.active]: location === destination
      }),
      href: destination
    };
  };

  return (
    <Drawer
      open={isOpen}
      direction="left"
      zIndex={70}
      size="75vw"
      className={styles.menuDrawer}
      customIdSuffix="_strava_mobile_menu"
      onClose={onClose}
      style={{ '--marginTop': top }}
      lockBackgroundScroll={true}
    >
      <ul className={styles.primaryOptions}>
        {PRIMARY_OPTIONS.map(({ key, destination }) => (
          <li key={key}>
            <a {...generateLinkProps({ key, destination })}>
              {t(`header.menu.${key}`)}
            </a>
          </li>
        ))}
      </ul>

      <ul className={styles.secondaryOptions}>
        {SECONDARY_OPTIONS.map(({ key, destination }) => (
          <li key={key}>
            <a {...generateLinkProps({ key, destination })}>
              {t(`header.menu.${key}`)}
            </a>
          </li>
        ))}
      </ul>

      <ul className={styles.menuList}>
        <li>
          <Button
            type="button"
            onClick={handleLoginBtnClick}
            className={styles.menuDrawerBtn}
            data-cy="mobile-nav-drawer-login-btn"
          >
            {t('header.log_in')}
          </Button>
        </li>

        <li>
          <CallToAction
            element="get_app"
            className={styles.drawerCallToAction}
            label={t('header.get_the_app')}
            dataCy="mobile-nav-drawer-signup-btn"
            onClick={onMobileHeaderMenuSignupBtnClick}
          />
        </li>
      </ul>
    </Drawer>
  );
};

MenuDrawer.defaultProps = {
  top: 0
};

MenuDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  top: PropTypes.number
};

export default MenuDrawer;
